module.exports = __webpack_public_path__ + "static/media/instagram.01795a27.svg";